import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; // Assuming React Router is used for navigation
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faGear, faArrowRight, faTimes, faBars, faSave, faShare, faClock, faSearch } from '@fortawesome/free-solid-svg-icons';
import BlogPost from "../blogpost/BlogPost"; // Import the BlogPost component
import { Bookmark } from 'lucide-react';
import { API_BASE_URL } from "./api";
import { useAuth } from '../components/AuthContext ';

const Blog = () => {
  const { isAuthenticated } = useAuth();
  const [search, setSearch] = useState("");
  const [blogs, setBlogs] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [TopBlogs, setTopBlogs] = useState([]);
  const [recommendedBlogs, setRecommendedBlogs] = useState([]);
  const [HealthyLifeBlogs, setHealthyLifeBlogs] = useState([]);
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}blog-posts/`);
        if (!response.ok) {
          throw new Error("Failed to fetch blogs");
        }
        const data = await response.json();
        setBlogs(data);
        setTopBlogs(data.slice(0, 3));
        setRecommendedBlogs(data.slice(3, 6));
        setHealthyLifeBlogs(data.slice(6, 15));
        setFilteredBlogs(data.slice(4, 15));
      } catch (error) {
        console.error(error);
      }
    };

    fetchBlogs();
  }, []);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    const searchValue = e.target.value.toLowerCase();
    const filtered = blogs.filter(
      (blog) =>
        (blog.title && blog.title.toLowerCase().includes(searchValue)) ||
        (blog.content && blog.content.toLowerCase().includes(searchValue))
    );
    setFilteredBlogs(filtered);
  };

  const handleShareEntry = (blogId) => {
    const blogUrl = `${window.location.origin}/blog/${blogId}`;
    navigator.clipboard.writeText(blogUrl)
        .then(() => {
            alert('Blog link copied to clipboard!');
        })
        .catch((err) => {
            console.error('Failed to copy the link: ', err);
        });
  };

  // Helper function to strip HTML tags and get plain text
  const stripHtml = (html) => {
    if (!html) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  const toggleSideNav = () => {
    setIsSideNavOpen(!isSideNavOpen);
  };


  return (
    <div className='flex min-h-screen bg-gray-100'>
      {/* Hamburger Menu Button for Small Screens */}
      {isAuthenticated() && (
        <button
          onClick={toggleSideNav}
          className="fixed top-4 left-4 z-30 md:hidden bg-[#59844F] text-white p-3 rounded-lg shadow-lg"
        >
          <FontAwesomeIcon icon={isSideNavOpen ? faTimes : faBars} size="lg" />
        </button>
      )}

      {/* Side Navigation Bar - Only show when logged in */}
      {isAuthenticated() && (
        <div className={`transform ${isSideNavOpen ? 'translate-x-0' : '-translate-x-full'} w-[280px] bg-white shadow-lg transition-transform duration-300 ease-in-out z-20 md:translate-x-0 fixed md:sticky top-0 h-screen overflow-y-auto`}>
          <div className="p-6">
            <nav>
              <ul className="space-y-2">
                <li><button className="w-full text-left py-2 px-4 hover:bg-gray-100 rounded"><Link to="/sereniai" className="flex items-center font-semibold">🤖 SereniAI</Link></button></li>
                <li><button className="w-full text-left py-2 px-4 hover:bg-gray-100 rounded">
                  <Link to="/book-professionals" className="flex items-center font-semibold">📚 Book our Professionals</Link>
                </button></li>
                <li><button className="w-full text-left py-2 px-4 hover:bg-gray-100 rounded">
                  <Link to="/activity-lounge" className="flex items-center font-semibold">🎮 Activity Lounge</Link>
                </button></li>
                <li><button className="w-full text-left py-2 px-4 hover:bg-gray-100 rounded bg-[#59844F] text-white">
                  <Link to="/blog" className="flex items-center font-semibold">📝 Blog</Link>
                </button></li>
                <li><button className="w-full text-left py-2 px-4 hover:bg-gray-100 rounded">
                  <Link to="/journal" className="flex items-center font-semibold">✍🏼 Your Journal</Link>
                </button></li>
                <li><button className="w-full text-left py-2 px-4 hover:bg-gray-100 rounded">
                  <Link to="/community" className="flex items-center font-semibold">👥 Community</Link>
                </button></li>
              </ul>
            </nav>
          </div>
        </div>
      )}

      <div className={`container mx-auto px-4 ${isAuthenticated() ? 'md:w-[900px]' : 'w-[1000px]'}`}>
        <div className="container py-8">
          <div className="flex items-center justify-center mb-4">
            <input
              type="text"
              placeholder="Search by category..."
              value={search}
              onChange={handleSearch}
              className="px-4 py-2 mr-2 border border-gray-300 rounded-md"
            />
            <button className="flex items-center px-4 py-2 text-white bg-[#59844F] rounded-md">
              <FontAwesomeIcon icon={faSearch} className="mr-2" />
              Search
            </button>
          </div>

          {/* Trending Blogs Section */}
          <div className="">
            <h1 className="text-3xl font-bold underline my-9 text-center">Our Trending Blogs</h1>
          </div>
          <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 ">
            {TopBlogs.length > 0 ? (
              TopBlogs.map(blog => (
                <div key={blog.id} className="p-4 bg-white rounded-lg shadow-md hover:bg-[#a8c9af]">
                  <Link to={`/blog/${blog.id}`} className="block">
                    <img src={blog.image} alt="Blog Image" className=" rounded-lg h-[200px] w-full" />
                  </Link>
                  <div className="p-6">
                <h2 className="text-[20px] font-bold mb-2 text-center">{blog.title}</h2>
                <p className="text-gray-600 text-sm text-center mb-4">
                {stripHtml(blog.content).substring(0, 100)}...
                </p>
                <p className="text-gray-500 text-xs mb-4 text-center">{blog.date}</p>
                <div className="flex justify-center items-center ">
                <Link to={`/blog/${blog.id}`} className="block">
                  <button className="px-4 py-2 bg-white text-gray-700 border border-gray-300 rounded hover:bg-gray-100 transition-colors duration-200">
                    Read More
                  </button>
                  </Link>
                  <FontAwesomeIcon 
                icon={faShare} 
                className="text-gray-400 ml-3 hover:text-gray-600 cursor-pointer" 
                size={30} 
                onClick={() => handleShareEntry(blog.id)}
/>
                </div>
              </div>
                  {/* Additional details */}
                  <div className="flex justify-between mt-4">
                    
                  </div>
                  <div className="flex justify-between mt-4">
                    <div className="flex items-center">
                      <p className="text-sm text-gray-500">{blog.author}</p>
                    </div>
                    <div className="flex items-center">
                      <p className="text-sm text-gray-500">
                        <FontAwesomeIcon icon={faClock} /> {blog.readingTime}
                      </p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No trending blogs found</p>
            )}
          </div>

          {/* Recommendations Section */}
          <div>
            <h1 className="text-3xl font-bold underline my-9 text-center">Recommended Blogs</h1>
          </div>
          <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            {recommendedBlogs.length > 0 ? (
              recommendedBlogs.map(blog => (
                <div key={blog.id} className="p-4 bg-white rounded-lg shadow-md hover:bg-[#a8c9af]">
                  <Link to={`/blog/${blog.id}`} className="block">
                    <img src={blog.image} alt="Blog Image" className=" rounded-lg h-[200px] w-full" />
                  </Link>
                  <div className="p-6">
                <h2 className="text-[20px] font-bold mb-2 text-center">{blog.title}</h2>
                <p className="text-gray-600 text-sm text-center mb-4">
                {stripHtml(blog.content).substring(0, 100)}...
                </p>
                <p className="text-gray-500 text-xs mb-4 text-center">{blog.date}</p>
                <div className="flex justify-center items-center ">
                <Link to={`/blog/${blog.id}`} className="block">
                  <button className="px-4 py-2 bg-white text-gray-700 border border-gray-300 rounded hover:bg-gray-100 transition-colors duration-200">
                    Read More
                  </button>
                  </Link>
                  <FontAwesomeIcon 
                  icon={faShare} 
                  className="text-gray-400 ml-3 hover:text-gray-600 cursor-pointer" 
                  size={30} 
                  onClick={() => handleShareEntry(blog.id)}
              />
                </div>
              </div>
                  {/* Additional details */}
                  <div className="flex justify-between mt-4">
                    
                  </div>
                  <div className="flex justify-between mt-4">
                    <div className="flex items-center">
                      <p className="text-sm text-gray-500">{blog.author}</p>
                    </div>
                    <div className="flex items-center">
                      <p className="text-sm text-gray-500">
                        <FontAwesomeIcon icon={faClock} /> {blog.readingTime}
                      </p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No recommended blogs available</p>
            )}
          </div>

          {/* Healthy Life Section */}
          <div>
            <h1 className="text-3xl font-bold underline my-9 text-center">Healthy Life Blogs</h1>
          </div>
          <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            {HealthyLifeBlogs.length > 0 ? (
              HealthyLifeBlogs.map(blog => (
                <div key={blog.id} className="p-4 bg-white rounded-lg shadow-md hover:bg-[#a8c9af]">
                  <Link to={`/blog/${blog.id}`} className="block">
                    <img src={blog.image} alt="Blog Image" className=" rounded-lg h-[200px] w-full" />
                  </Link>
                  <div className="p-6">
                <h2 className="text-[20px] font-bold mb-2 text-center">{blog.title}</h2>
                <p className="text-gray-600 text-sm text-center mb-4">
                {stripHtml(blog.content).substring(0, 100)}...
                </p>
                <p className="text-gray-500 text-xs mb-4 text-center">{blog.date}</p>
                <div className="flex justify-center items-center ">
                <Link to={`/blog/${blog.id}`} className="block">
                  <button className="px-4 py-2 bg-white text-gray-700 border border-gray-300 rounded hover:bg-gray-100 transition-colors duration-200">
                    Read More
                  </button>
                  </Link>
                  <FontAwesomeIcon 
                    icon={faShare} 
                    className="text-gray-400 ml-3 hover:text-gray-600 cursor-pointer" 
                    size={30} 
                    onClick={() => handleShareEntry(blog.id)}
                />
                  </div>
              </div>
                  {/* Additional details */}
                  <div className="flex justify-between mt-4">
                    
                  </div>
                  <div className="flex justify-between mt-4">
                    <div className="flex items-center">
                      <p className="text-sm text-gray-500">{blog.author}</p>
                    </div>
                    <div className="flex items-center">
                      <p className="text-sm text-gray-500">
                        <FontAwesomeIcon icon={faClock} /> {blog.readingTime}
                      </p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No recommended blogs available</p>
            )}
          </div>
        </div>

        <Link to="/createblog" className="fixed px-4 py-2 text-white bg-[#59844F] rounded-full shadow-md bottom-4 right-4 create-btn">
          <svg xmlns="http://www.w3.org/2000/svg" className="inline-block w-6 h-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          Create Blog Now
        </Link>
      </div>
    </div>
  );
};

export default Blog;
 